export const LINKS = {
    LEARN_MORE: 'https://ton.org/wallets'
};
